import { FormEvent, useState } from "react"
import type { LandingCopy, LandingLocale } from "./landingCopy"
import { submitLandingContact } from "./landingContact"

const ContactForm = ({ copy, locale }: { copy: LandingCopy; locale: LandingLocale }) => {
  const [ name, setName ] = useState("")
  const [ email, setEmail ] = useState("")
  const [ message, setMessage ] = useState("")
  const [ honeypot, setHoneypot ] = useState("")
  const [ status, setStatus ] = useState<"idle" | "sending" | "ok" | "error">("idle")

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (status === "sending") return
    setStatus("sending")
    try {
      const res = await submitLandingContact({
        name,
        email,
        message,
        companyWebsite: honeypot,
        locale,
      })
      if (res.ok) {
        setStatus("ok")
        setName("")
        setEmail("")
        setMessage("")
        setHoneypot("")
        return
      }
      setStatus("error")
    } catch {
      setStatus("error")
    }
  }

  return (
    <form className="landing-contact-form" onSubmit={onSubmit}>
      <label className="landing-field">
        <span>{copy.contactNameLabel}</span>
        <input
          type="text"
          name="name"
          required
          maxLength={120}
          value={name}
          onChange={e => setName(e.target.value)}
          autoComplete="name"
        />
      </label>
      <label className="landing-field">
        <span>{copy.contactEmailLabel}</span>
        <input
          type="email"
          name="email"
          required
          maxLength={200}
          value={email}
          onChange={e => setEmail(e.target.value)}
          autoComplete="email"
        />
      </label>
      <label className="landing-field">
        <span>{copy.contactMessageLabel}</span>
        <textarea
          name="message"
          required
          rows={5}
          maxLength={4000}
          value={message}
          onChange={e => setMessage(e.target.value)}
        />
      </label>
      <label className="landing-honeypot" aria-hidden="true">
        <span>Company website</span>
        <input
          type="text"
          name="companyWebsite"
          tabIndex={-1}
          autoComplete="off"
          value={honeypot}
          onChange={e => setHoneypot(e.target.value)}
        />
      </label>
      <button className="landing-btn landing-btn-primary" type="submit" disabled={status === "sending"}>
        {status === "sending" ? copy.contactSending : copy.contactSubmit}
      </button>
      {status === "ok" ? <p className="landing-form-note is-success">{copy.contactSuccess}</p> : null}
      {status === "error" ? <p className="landing-form-note is-error">{copy.contactError}</p> : null}
    </form>
  )
}

export default ContactForm
